import { render, staticRenderFns } from "./SidesheetEdicionAcuerdo.vue?vue&type=template&id=2349806a"
import script from "./SidesheetEdicionAcuerdo.vue?vue&type=script&lang=js"
export * from "./SidesheetEdicionAcuerdo.vue?vue&type=script&lang=js"
import style0 from "./SidesheetEdicionAcuerdo.vue?vue&type=style&index=0&id=2349806a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
